/**
 * Whether the camera shutter should be on screen at all.
 *
 * It used to render on "no photo taken yet" alone, so it sat over "Conectando ao stream…"
 * inviting a press that could only fail — there is nothing to capture until a frame has
 * actually arrived. A live frame is what makes the shutter meaningful.
 */
export function canCaptureFrame(input: {
  /** The latest frame from the stream; null/empty until one arrives. */
  previewUrl: string | null | undefined;
  /** Set once a photo has been taken — that screen is the editor, not the camera. */
  imageSrc: string | null | undefined;
  isCapturing: boolean;
}): boolean {
  return Boolean(input.previewUrl) && !input.imageSrc && !input.isCapturing;
}
